import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { JournalTab } from "../Toolbox/components/JournalTab";

export default function ToolboxResponsesPage() {
  const { topicId } = useParams<{ topicId: string }>();
  if (!topicId) {
    return <Navigate to="/error" replace />;
  }
  const backTo = `/toolboxes/${topicId}`;
  return (
    <div className="w-full space-y-4 pt-4">
      <Link
        to={backTo}
        className="flex items-center gap-1.5 text-sm text-electrum-300 hover:text-electrum transition-colors w-fit"
      >
        <ArrowLeftIcon className="w-4 h-4" />
        Back to toolbox
      </Link>
      <JournalTab topicId={topicId} />
    </div>
  );
}
